export default __webpack_public_path__ + "static/media/about.6a983b72.gif";